module.exports = __webpack_public_path__ + "img/brown-wooden-stool-3236265.f452eb1a.jpg";